import { baseApi } from "./apiSingleton";

export interface IGetShipContentResponse {
  [x: string]: any;
  grades: Array<{
    code: string;
    name: string;
    meta_category: string;
    description: Array<{ description: string }>;
    valid_from: typeof Date;
    valid_to: typeof Date;
    cabin_qty: number;
    colour_code: string;
    images: Array<{
      image: string;
      size: string;
    }>;
  }>;
}

export interface IGetShipContentRequest {
  ship_code: string;
  language: string;
}

interface IRates {
  code: string;
  name: string;
}

export const ContentAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getShipContent: builder.query<
      IGetShipContentResponse,
      IGetShipContentRequest
    >({
      query: ({ ship_code, language }) => ({
        url: `/avl/ships/${ship_code}/?language=${language}`,
        method: "GET",
      }),
    }),
    getResidentialRates: builder.query<IRates[], null>({
      query: () => {
        return {
          url: `/export/codes/residential_code/`,
          method: "GET",
        };
      },
      transformResponse: (response: IRates[]) => {
        return [...response].sort((a, b) =>
          a.name.localeCompare(b.name, undefined, { sensitivity: "base" }),
        );
      },
    }),
  }),
});

export const { useLazyGetShipContentQuery, useGetResidentialRatesQuery } =
  ContentAPI;
